import { useCurrentUserSettings } from "services/userSettingsService";
import { useApplicationSettings } from "services/applicationSettingsService";

/**
 * Generic hook to resolve a setting value by key.
 *
 * Looks the key up in the current user's settings first (when
 * `checkUserSetting` is true and a non-empty value is found there),
 * falling back to the application-wide setting otherwise.
 *
 * @param {string} settingKey - e.g. "DefaultEmailClient"
 * @param {boolean} [checkUserSetting=true] - whether to check the user's
 *   own setting before falling back to the application setting.
 * @returns {string | undefined} resolved setting value
 */
export const useSetting = (settingKey, checkUserSetting = true) => {
  const { data: userSettings } = useCurrentUserSettings();
  const { data: applicationSettings } = useApplicationSettings();

  const userValue = checkUserSetting
    ? userSettings?.find((x) => x.key === settingKey)?.value
    : undefined;

  if (userValue?.trim()) {
    return userValue;
  }

  return applicationSettings?.find((x) => x.key === settingKey)?.value;
};
